module.exports = __webpack_public_path__ + "img/advancedattender.bd501732.png";